import { render } from "./Pma.vue?vue&type=template&id=50d9dec6&scoped=true"
import script from "./Pma.vue?vue&type=script&lang=js"
export * from "./Pma.vue?vue&type=script&lang=js"

import "./Pma.vue?vue&type=style&index=0&id=50d9dec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d9dec6"]])

export default __exports__